import React from "react";
import PropTypes from "prop-types";
import { Flex } from "@evertrue/et-components";
import moment from "moment";
import { parseMessage, getETUserIDFromChatKitUser } from "../utils/utils";
import Highlighter from "react-highlight-words";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";
import ChatEtUserCard from "./chat-et-user-card";

const formatMessageTime = time => moment(time).format("h:mm a");

const Message = ({ message, searchText }) => {
  const { oid, app } = useChatDependencyContext();
  const parsed_message = parseMessage(message);
  const chatkit_sender = parsed_message.sender;
  const et_user_id = getETUserIDFromChatKitUser(oid, chatkit_sender.id);

  return (
    <div className="message">
      <div className="message--top">
        <Flex alignItems="center">
          <ChatEtUserCard userId={et_user_id}>
            <div className="message--time">{formatMessageTime(parsed_message.createdAt)}</div>
          </ChatEtUserCard>
        </Flex>
      </div>
      <Highlighter
        className="message--text"
        searchWords={searchText ? searchText.split(" ") : []}
        autoEscape={true}
        textToHighlight={parsed_message.text}
      />

      {app !== "vms" && (
        <div className="message--time" style={{ marginTop: 12 }}>
          Message ID: {parsed_message.id}
        </div>
      )}
    </div>
  );
};

Message.propTypes = {
  message: PropTypes.object,
  searchText: PropTypes.string,
};

export default Message;
